export function getDollarDataApi() {
  const url = 'https://api.bluelytics.com.ar/v2/latest';

  return fetch(url)
    .then(async (response) => {
      return { code: response.status, data: await response.json() };
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}
